import {
  Card,
  CardContent,
  Avatar,
  Typography,
  CardActions,
  IconButton,
  Box,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import React from "react";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import useApiEp from "../../../hooks/useApiEp";

const TeamMembersList = ({ user }) => {
  const { data, isLoading, isError } = useApiEp(
    `/user/get-team-members?id=${user.username}`
  );
  return (
    <Box display="flex" gap={3} flexWrap="wrap">
      {data?.data?.map((member, index) => (
        <Card
          key={index}
          elevation={0}
          sx={{
            width: 260,
            borderRadius: 4,
            border: "1px solid #eef2f6",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            textAlign: "center",
            padding: 3,
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
            },
          }}
        >
          <Box display="flex" justifyContent="center" mb={2}>
            <Avatar
              src={member.profile_image}
              sx={{
                width: 86,
                height: 86,
                bgcolor: "#0f4a5f",
                fontSize: "1.5rem",
                fontWeight: 600,
              }}
            >
              {!member.profile_image &&
                `${member.firstName.charAt(0)}${member.lastName.charAt(0)}`}
            </Avatar>
          </Box>
          <CardContent sx={{ padding: 0, paddingBottom: 2 }}>
            <Typography
              variant="h6"
              fontWeight={700}
              color="#1e293b"
              gutterBottom
            >
              {`${member.firstName} ${member.lastName}`}
            </Typography>
            <Typography variant="body2" color="#64748b" fontWeight={500} mb={2}>
              {member.designation || "Team Member"}
            </Typography>
            {member.email && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mb={1}
                gap={1}
              >
                <EmailIcon sx={{ color: "#94a3b8", fontSize: 18 }} />
                <Typography variant="body2" color="#475569" fontWeight={500}>
                  {member.email}
                </Typography>
              </Box>
            )}
            {member.phone && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mb={1}
                gap={1}
              >
                <PhoneIcon sx={{ color: "#94a3b8", fontSize: 18 }} />
                <Typography variant="body2" color="#475569" fontWeight={500}>
                  {member.phone}
                </Typography>
              </Box>
            )}
          </CardContent>
          <CardActions
            sx={{ justifyContent: "center", paddingTop: 1, paddingBottom: 0 }}
          >
            {member.email && (
              <IconButton
                aria-label="send email"
                href={`/${user?.role}/chat?tid=${encodeURIComponent(
                  member.owner
                )}`}
                size="small"
                sx={{
                  color: "#64748b",
                  "&:hover": {
                    color: "#0f4a5f",
                    bgcolor: "rgba(15,74,95,0.08)",
                  },
                }}
              >
                <ForumOutlinedIcon fontSize="small" />
              </IconButton>
            )}
            {member.phone && (
              <IconButton
                aria-label="call"
                href={`/${
                  user?.role
                }/meeting-scheduler?tid=${encodeURIComponent(member.owner)}`}
                size="small"
                sx={{
                  color: "#64748b",
                  "&:hover": {
                    color: "#0f4a5f",
                    bgcolor: "rgba(15,74,95,0.08)",
                  },
                }}
              >
                <CalendarMonthIcon fontSize="small" />
              </IconButton>
            )}
          </CardActions>
        </Card>
      ))}
    </Box>
  );
};

export default TeamMembersList;
